import React from 'react';
import { Check } from 'lucide-react';

export default function WelcomeStep() {
  return (
    <div className="text-center py-8" data-testid="welcome-step">
      <h2 className="text-3xl font-bold text-[#0f172a] mb-4" style={{ fontFamily: 'Outfit, sans-serif' }} data-testid="client-profile-welcome-title">
        Welcome to Your Client Profile
      </h2>
      <p className="text-[#475569] mb-6" style={{ fontFamily: 'Manrope, sans-serif' }}>
        This comprehensive questionnaire will help us understand your financial situation and goals.
      </p>
      <div className="space-y-4 text-left max-w-md mx-auto">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#5b93d6] flex items-center justify-center mt-0.5">
            <Check className="w-4 h-4 text-white" />
          </div>
          <p className="text-sm text-[#475569]">Your progress is automatically saved as you go</p>
        </div>
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#5b93d6] flex items-center justify-center mt-0.5">
            <Check className="w-4 h-4 text-white" />
          </div>
          <p className="text-sm text-[#475569]">You can return anytime to complete the form</p>
        </div>
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#5b93d6] flex items-center justify-center mt-0.5">
            <Check className="w-4 h-4 text-white" />
          </div>
          <p className="text-sm text-[#475569]">All information is securely encrypted and confidential</p>
        </div>
      </div>
    </div>
  );
}
